import { emitDatadogError } from "@faire/web--source/common/datadog/rum";
import { getWebApiErrorMessage } from "@faire/web--source/common/getErrorMessage";
import { getNormalizedUrl } from "@faire/web--source/common/getNormalizedUrl";
import { WebApiError } from "@faire/web-api--source/WebApiError";
import { WebApiNetworkError } from "@faire/web-api--source/WebApiNetworkError";
import { WebApiRequestCancellationError } from "@faire/web-api--source/WebApiRequestCancellationError";
import { mockStrictLocalize } from "../../testing/unit/mockStrictLocalize";
var Severity;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
var createFingerprint = function(method, url) {
    var statusCode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return [
        "apiError",
        method,
        getNormalizedUrl(url),
        "".concat(statusCode)
    ];
};
// The request was made and the server responded with a status code
// that falls out of the range of 2xx
export var logErrorResponse = function(error, requestOptions) {
    var httpStatusCode = error.httpStatusCode;
    if (httpStatusCode === undefined || httpStatusCode > 399) {
        return;
    }
    var errorMessage = getWebApiErrorMessage(error, mockStrictLocalize);
    var method = requestOptions.method, url = requestOptions.url;
    var message = "".concat((method || "Unknown").toUpperCase(), " ").concat(url, " received a ").concat(httpStatusCode, ": ").concat(errorMessage);
    emitDatadogError({
        message: message,
        resource: {
            url: url
        },
        stack: createFingerprint(method, url, httpStatusCode)
    }, {
        level: Severity.Debug,
        data: {
            config: requestOptions,
            responseStatus: httpStatusCode
        }
    });
};
// The request was made but no response was received
// OR
// Something happened in setting up the request that triggered an Error
var logErrorRequest = function(error, requestOptions) {
    var method = requestOptions.method, url = requestOptions.url;
    var message = "No response: ".concat(error.message || "Unknown");
    emitDatadogError({
        message: message,
        resource: {
            url: url
        },
        stack: createFingerprint(method, url)
    }, {
        level: Severity.Debug,
        data: {
            error: error,
            config: requestOptions
        }
    });
};
export var errorLoggingInterceptor = function(requestOptions, response) {
    if (!("error" in response) || response.error instanceof WebApiRequestCancellationError) {
        return response;
    }
    if (response.error instanceof WebApiNetworkError) {
        logErrorRequest(response.error, requestOptions);
    } else if (response.error instanceof WebApiError) {
        logErrorResponse(response.error, requestOptions);
    }
    return response;
};
